import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core'
import {ReactFeatureApp} from '@feature-hub/react'
import React from 'react'
import {Provider} from 'react-redux'
import {App} from './app/app'
import {store} from './app/store'
import {AppConfig} from './common/configuration'
import './i18n'
import {FeatureServicesContext} from './use-feature-services'
import {ThemeProvider} from '@volkswagen-onehub/components-core'
import {LayerManagerV2} from '@volkswagen-onehub/layer-manager'
import {CmsServiceV1 as CmsService} from '@volkswagen-onehub/cms-service'

export interface Dependencies extends FeatureServices {
    readonly 's2:logger'?: Logger
    readonly 'layer-manager'?: LayerManagerV2
    readonly 'cms-service': CmsService
}

export const featureAppDefinition: FeatureAppDefinition<
    ReactFeatureApp,
    Dependencies,
    AppConfig
> = {
    optionalDependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
            'breadcrumb-service': '^1.0.0',
            'tracking': '^1.0.0',
            's2:history': '^2.0.0',
            'service-config-provider': '1.0.0',
            'fa-content-service': '^1.0.0',
            'featureapp-service': '^1.0.0',
            'layer-manager': '^2.5.0',
            'vw:authService': '^2.0.0',
            'vw:authservice-config': '^2.0.0',
            'mydealer-service': '^2.0.0',
            'cms-service': '^1.0.0',
        },
    },
    create: ({featureAppId, featureServices, config, baseUrl}) => {
        // tslint:disable-next-line:no-any
        const faContentService = featureServices['fa-content-service'] as any

        return {
            render(): React.JSX.Element {
                return (
                    <FeatureServicesContext.Provider value={featureServices}>
                        <ThemeProvider theme="main">
                            <Provider store={store}>
                                <App
                                    trackingBrand={
                                        faContentService.content?.trackingBrand
                                    }
                                    backendUrl={config?.backendUrl}
                                    preview_date={
                                        faContentService.content?.preview_date
                                    }
                                    brand={faContentService.content.brand}
                                    previewAPIToken={config?.previewAPIToken}
                                    featureAppId={featureAppId}
                                    baseUrl={baseUrl}
                                    modelFromCms={
                                        faContentService.content?.model
                                    }
                                    layout={faContentService.content?.layout}
                                    showRFQForm={
                                        faContentService.content?.showRFQForm
                                    }
                                    autoloadRFQFormTimingDesktop={
                                        faContentService?.content
                                            ?.autoloadRFQFormTimingDesktop
                                    }
                                    autoloadRFQFormTimingMobile={
                                        faContentService?.content
                                            ?.autoloadRFQFormTimingMobile
                                    }
                                    fivePlusLayerPath={
                                        faContentService?.content
                                            ?.fivePlusLayerPath
                                    }
                                />
                            </Provider>
                        </ThemeProvider>
                    </FeatureServicesContext.Provider>
                )
            },
        }
    },
}

export default featureAppDefinition
